<template>
    <div class="py-4">
        <header>
            <div class="container-fluid">
                <div class="pb-4">
                    <div class="row align-items-end">
                        <div class="col">
                            <div class="d-flex align-items-center gap-4">
                                <div>
                                    <button type="button" class="btn-close text-xs" @click="$router.go(-1)"></button>
                                </div>
                                <div class="vr opacity-20 my-1"></div>
                                <div>
                                    <h1 class="h4 ls-tight">Factura electrónica - {{ data.type }}{{ data.id }}</h1>
                                </div>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="hstack gap-2 justify-content-end">
                                <button @click="GENERATE()" type="button" class="btn btn-success btn-h px-3" v-if="!primary && !loading || loading === 'generate'">
                                    <div class="spinner-border spinner-border-sm" role="status" v-if="count == 1">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <small v-else><i class="fa-solid fa-rotate-right"></i> Generar FEL</small>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        <main class="py-6 bg-surface-secondary">
            <div class="container-fluid vstack gap-5">
                <div class="w-100 pt-5" v-if="loading == 'table'">
                    <div class="text-center">
                        <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header bg-white">
                                <h5 class="me-auto">Listado</h5>
                            </div>
                            <div class="card-body p-0">
                                <v-data-table class="elevation-1" :headers="headers" :items="data.fels" :loading="loading == 'table'" :item-class="ITEM_ROW_BACKGROUND">
                                    <template v-slot:[`item.created_at`]="{ item }">
                                        {{ item.created_at | DATETIME }}
                                    </template>
                                    <template v-slot:[`item.tipo_documento`]="{ item }">
                                        {{ item.tipo_documento | TIPODOCUMENTO }}
                                    </template>
                                    <template v-slot:[`item.estado`]="{ item }">
                                        <v-tooltip bottom class="mx-1">
                                            <template v-slot:activator="{ on, attrs }">
                                                <div v-bind="attrs" v-on="on" class="nowrap">
                                                    {{ item.estado | ESTADO }} ...
                                                </div>
                                            </template>
                                            <small>
                                                {{ item.estado | ESTADO }}
                                            </small>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.xml_error`]="{ item }">
                                        <v-tooltip bottom class="mx-1">
                                            <template v-slot:activator="{ on, attrs }">
                                                <div v-bind="attrs" v-on="on" class="nowrap">
                                                    {{ item.xml_error }} ...
                                                </div>
                                            </template>
                                            <small>
                                                {{ item.xml_error }}
                                            </small>
                                        </v-tooltip>
                                    </template>
                                    <template v-slot:[`item.pdf`]="{ item, index }">
                                        <a :href="COMPROBANTES_ELECTRONICOS_URL + '/action_xml.php?token=' + item.clave + '&op=pdf&ambiente=' + COMPROBANTES_ELECTRONICOS_AMBIENTE" download target="_blank" class="btn btn-danger btn-h" v-if="item.estado == 1">
                                            <small><i class="fa-solid fa-file-pdf"></i></small>
                                        </a>
                                    </template>
                                    <template v-slot:[`item.xml`]="{ item, index }">
                                        <a :href="COMPROBANTES_ELECTRONICOS_URL + '/action_xml.php?token=' + item.clave + '&op=xml&ambiente=' + COMPROBANTES_ELECTRONICOS_AMBIENTE" download target="_blank" type="button" class="btn btn-dark btn-h" v-if="item.estado == 1">
                                            <small><i class="fa-solid fa-file"></i></small>
                                        </a>
                                    </template>
                                    <template v-slot:[`item.response`]="{ item, index }">
                                        <a :href="COMPROBANTES_ELECTRONICOS_URL + '/action_xml.php?token=' + item.clave + '&op=hacienda&ambiente=' + COMPROBANTES_ELECTRONICOS_AMBIENTE" download target="_blank" class="btn btn-dark btn-h" v-if="item.estado == 1">
                                            <small><i class="fa-solid fa-file"></i></small>
                                        </a>
                                    </template>
                                    <template v-slot:[`item.reenviar`]="{ item }">
                                        <button @click="REENVIAR_FEL()" type="button" class="btn btn-primary btn-h" v-if="item.estado == 1">
                                            <small><i class="fa-solid fa-paper-plane"></i></small>
                                        </button>
                                    </template>
                                </v-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import maintenance from '@/assets/img/maintenance.svg'
export default {
    data(){
        return {
            maintenance,
            loading: 'table',
            headers: [
                { text: 'Tipo', value: 'tipo_documento', sortable: false },
                { text: 'Clave', value: 'clave', sortable: false },
                { text: 'Fecha', value: 'created_at', sortable: false },
                { text: 'Estado', value: 'estado', sortable: false },
                { text: 'Mensaje', value: 'xml_error', sortable: false },
                { text: 'Descargar PDF', value: 'pdf', sortable: false },
                { text: 'Descargar XML', value: 'xml', sortable: false },
                { text: 'Respuest XML', value: 'response', sortable: false },
                { text: 'Reenviar FEL', value: 'reenviar', sortable: false },
            ],
            data: {
                fels: []
            },
            loadings: [],
            id: this.$route.params.id,
            count: 0,
            COMPROBANTES_ELECTRONICOS_URL: process.env.COMPROBANTES_ELECTRONICOS_URL,
            COMPROBANTES_ELECTRONICOS_AMBIENTE: process.env.COMPROBANTES_ELECTRONICOS_AMBIENTE,
        }
    },
    mounted() {
        this.INIT()
    },
    computed: {
        primary: function () {
            return this.data.fels.find((e) => e.estado == 1)
        }
    },
    methods: {
        ITEM_ROW_BACKGROUND: function (item) {
            return item.estado == 1 ? 'bg-alert-success' : 'bg-alert-warning'
        },
        INIT: function () {
            let vue = this
            vue.loading = 'table'
            axios({ url: '/packages/' + vue.id + '/fel', method: 'GET' })
                .then((resp) => {
                    vue.data = resp.data
                })
                .catch((err) => {
                   let message = err.response ? err.response.data.message : err.message
                    vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                })
                .finally((resp) => {
                    vue.loading = ''
                })
        },
        REENVIAR_FEL: function(){
            this.$swal({ toast: true, icon: 'warning', title: 'Esta opción se encuentra en mantenimiento', position: 'top-end', showConfirmButton: false, timer: 3000 })
        },
        GENERATE: function(){
            let vue = this
            vue.loading = 'generate'
            vue.count++
            if (vue.count == 1) {
                axios({ url: '/packages/' + vue.id + '/fel/generate', method: 'POST' })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    })
                    .catch((err) => {
                        let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    })
                    .finally((resp) => {
                        vue.count = 0
                        vue.loading = ''
                    })
            }
        },
    },
}
</script>